import React, { Fragment } from "react";
import DOMPurify from "dompurify";
import {
  FaInfoCircle,
  FaExclamationCircle,
  FaCheckCircle,
  FaExclamationTriangle,
} from "react-icons/fa";
import Condition from "../Conditionals/Condition";

const titleStyle = {
  fontSize: "1.1rem",
  marginTop: ".6rem",
  lineHeight: "1.12707",
  marginBottom: ".5rem",
};

const alertContainerStyle = {
  minWidth: "100%",
  marginTop: "1rem",
  padding: "1.25rem 1.25rem 1.25rem 1.75rem",
  borderLeft: "9px solid",
  lineHeight: "1.52155",
  position: "relative",
  display: "flex",
};

const textStyle = {
  fontSize: ".95rem",
  marginTop: "0",
  marginBottom: "0",
};

const infoStyle = {
  backgroundColor: "#e7f6f8",
  borderColor: "#00bde3",
};

const successStyle = {
  backgroundColor: "#ecf3ec",
  borderColor: "#00a91c",
};

const errorStyle = {
  backgroundColor: "#f4e3db",
  borderColor: "#d63e04",
};

const warningStyle = {
  backgroundColor: "#faf3d1",
  borderColor: "#ffbe2e",
};

const defaultStyle = {
  backgroundColor: "#f0f0f0",
  borderColor: "#a9aeb1",
};

const PageAlert = (props) => {
  const { title, description, type, groupedAlerts, formApi } = props;

  let s_title = (props.schemaProps && props.schemaProps.title) || undefined;
  let s_type = (props.schemaProps && props.schemaProps.type) || undefined;
  let s_description =
    (props.schemaProps && props.schemaProps.description) || undefined;
  let s_customStyle =
    (props.schemaProps && props.schemaProps.customStyle) || undefined;

  let scsBackground = "";
  let scsBorder = "";

  if (s_customStyle) {
    scsBackground = s_customStyle.backgroundColor;
    scsBorder = s_customStyle.borderColor;
  }

  const customStyle =
    (type || s_type) === "customStyle"
      ? {
          backgroundColor: `${
            props.customStyle.backgroundColor || scsBackground
          }`,
          borderColor: `${props.customStyle.borderColor || scsBorder}`,
        }
      : null;

  const typeResolver = (typeOf) => {
    const types = {
      info: infoStyle,
      success: successStyle,
      error: errorStyle,
      custom: customStyle,
      warning: warningStyle,
      default: defaultStyle,
    };
    return types[typeOf] || defaultStyle;
  };

  const iconResolver = (typeOf) => {
    const icons = {
      info: FaInfoCircle,
      success: FaCheckCircle,
      error: FaExclamationTriangle,
      custom: props.customStyle ? props.customStyle.iconName : null,
      warning: FaExclamationCircle,
      default: null,
    };
    return icons[typeOf] || null;
  };

  const sanitizedHTML = (text) => (
    <span
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(text),
      }}
    />
  );

  return (
    <Fragment>
      <div style={{ ...alertContainerStyle, ...typeResolver(type || s_type) }}>
        <div style={{ marginRight: ".8rem" }}>
          {iconResolver(type || s_type) !== null
            ? React.createElement(
                iconResolver(type || s_type),
                {
                  size: "32px",
                  color: `${typeResolver(type || s_type).borderColor}`,
                },
                null
              )
            : null}
        </div>
        <div>
          {(title || s_title) && <h3 style={titleStyle}>{title || s_title}</h3>}
          <p className="usa-alert__text" style={textStyle}>
            {sanitizedHTML(description || s_description)}
            {!!groupedAlerts && (
              <ul style={{ paddingLeft: 30 }}>
                {groupedAlerts.map((groupedAlert) => {
                  return (
                    <Condition
                      when={
                        (groupedAlert?.isVisible &&
                          groupedAlert?.isVisible?.when) ||
                        undefined
                      }
                      is={
                        (groupedAlert?.isVisible &&
                          groupedAlert?.isVisible?.is) ||
                        undefined
                      }
                      operator={
                        (groupedAlert?.isVisible &&
                          groupedAlert?.isVisible?.operator) ||
                        undefined
                      }
                      formApi={formApi}
                      modal={
                        (groupedAlert?.isVisible &&
                          groupedAlert?.isVisible?.modal) ||
                        undefined
                      }
                    >
                      <li>
                        {sanitizedHTML(
                          groupedAlert?.description ||
                            groupedAlert?.s_description
                        )}
                      </li>
                    </Condition>
                  );
                })}
              </ul>
            )}
          </p>
        </div>
      </div>
    </Fragment>
  );
};

export default PageAlert;
